(function () {
  if (window.__spendingLeaderboardTitleInitialized) return;
  window.__spendingLeaderboardTitleInitialized = true;

  var activePopup = null;
  var returnFocusElement = null;
  var previousBodyOverflow = '';

  function text(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function formatDateRange(activity) {
    var start = text(activity && activity.orderStartAt);
    var end = text(activity && activity.orderEndAt);
    if (start && end) return start + ' - ' + end;
    return start || end;
  }

  function setText(element, value) {
    if (!element) return;
    element.textContent = value;
    element.hidden = !value;
  }

  function setSubtitle(titleBlock, value) {
    var container = titleBlock.querySelector('[data-slt-activity-subtitle]');
    var textEl = titleBlock.querySelector('[data-slt-activity-subtitle-text]');
    if (!textEl) return;
    textEl.textContent = value;
    if (container) container.hidden = !value;
  }

  function sanitizeHtml(html) {
    if (!html) return '';

    var template = document.createElement('template');
    template.innerHTML = String(html);
    var allowedTags = {
      A: true,
      B: true,
      BR: true,
      DIV: true,
      EM: true,
      H1: true,
      H2: true,
      H3: true,
      H4: true,
      H5: true,
      H6: true,
      I: true,
      LI: true,
      OL: true,
      P: true,
      SPAN: true,
      STRONG: true,
      TABLE: true,
      TBODY: true,
      TD: true,
      TFOOT: true,
      TH: true,
      THEAD: true,
      TR: true,
      U: true,
      UL: true,
    };
    var blockedTags = {
      EMBED: true,
      FORM: true,
      IFRAME: true,
      INPUT: true,
      LINK: true,
      MATH: true,
      META: true,
      OBJECT: true,
      SCRIPT: true,
      STYLE: true,
      SVG: true,
    };

    Array.prototype.slice.call(template.content.querySelectorAll('*')).forEach(function (node) {
      if (!node.parentNode) return;
      if (blockedTags[node.tagName]) {
        node.remove();
        return;
      }
      if (!allowedTags[node.tagName]) {
        node.replaceWith.apply(node, Array.prototype.slice.call(node.childNodes));
        return;
      }

      Array.prototype.slice.call(node.attributes).forEach(function (attribute) {
        var name = attribute.name.toLowerCase();
        var keep =
          (node.tagName === 'A' && (name === 'href' || name === 'target' || name === 'rel')) ||
          ((node.tagName === 'TD' || node.tagName === 'TH') &&
            (name === 'colspan' || name === 'rowspan'));
        if (!keep) node.removeAttribute(attribute.name);
      });

      if (node.tagName === 'A') {
        var href = node.getAttribute('href') || '';
        if (href && !/^(https?:|mailto:|tel:|\/|#)/i.test(href)) {
          node.removeAttribute('href');
        }
        if (node.getAttribute('target') === '_blank') {
          node.setAttribute('rel', 'noopener noreferrer');
        }
      }
    });

    return template.innerHTML;
  }

  function updateTracking(provider, title) {
    if (!provider || !title) return;

    ['v-track-visible:view_banner', 'v-track-context'].forEach(function (attributeName) {
      var raw = provider.getAttribute(attributeName);
      if (!raw) return;
      try {
        var payload = JSON.parse(raw);
        payload.title = title;
        provider.setAttribute(attributeName, JSON.stringify(payload));
      } catch (error) {
        return;
      }
    });
  }

  function applyActivity(titleBlock, activity) {
    if (!titleBlock || !activity) return;

    var title = text(titleBlock.getAttribute('data-override-title')) || text(activity.title);
    var subtitle =
      text(titleBlock.getAttribute('data-override-subtitle')) ||
      formatDateRange(activity);
    var termsTitle =
      text(titleBlock.getAttribute('data-override-terms')) ||
      text(activity.ruleTitle);

    setText(titleBlock.querySelector('[data-slt-activity-title-text]'), title);
    setSubtitle(titleBlock, subtitle);

    var termsWrap = titleBlock.querySelector('[data-slt-activity-terms-wrap]');
    var termsTrigger = titleBlock.querySelector('[data-slt-activity-terms-trigger]');
    var showTerms = titleBlock.getAttribute('data-show-terms') === '1';
    if (termsTrigger) termsTrigger.textContent = termsTitle;
    if (termsWrap) termsWrap.hidden = !showTerms || !termsTitle;

    var popup = titleBlock.querySelector('.slt-activity-popup');
    if (popup) {
      var popupTitle =
        text(popup.getAttribute('data-override-title')) ||
        text(activity.ruleTitle);
      setText(popup.querySelector('[data-slt-activity-popup-title]'), popupTitle);

      var popupContent = popup.querySelector('[data-slt-activity-popup-content]');
      if (popupContent && popup.getAttribute('data-override-content') !== '1') {
        var content = sanitizeHtml(activity.ruleContent);
        popupContent.innerHTML = content;
        popupContent.hidden = !content;
      }
    }

    updateTracking(titleBlock.closest('[data-activity-provider]'), title);
  }

  function initializeTitle(titleBlock) {
    if (!titleBlock || titleBlock.dataset.sltTitleInitialized === '1') return;
    titleBlock.dataset.sltTitleInitialized = '1';

    var provider = titleBlock.closest('[data-activity-provider]');
    if (!provider) return;

    provider.addEventListener('slt:data', function (event) {
      if (!event.detail) return;
      var activity =
        event.detail.activity ||
        (event.detail.json && event.detail.json.data && event.detail.json.data.activity);
      applyActivity(titleBlock, activity);
    });

    if (provider.sltCachedData) {
      var cachedActivity =
        provider.sltCachedData.activity ||
        (provider.sltCachedData.json &&
          provider.sltCachedData.json.data &&
          provider.sltCachedData.json.data.activity);
      applyActivity(titleBlock, cachedActivity);
    }
  }

  function initialize(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-slt-activity-title]')) {
      initializeTitle(scope);
    }
    scope.querySelectorAll('[data-slt-activity-title]').forEach(initializeTitle);
  }

  function closePopup() {
    if (!activePopup) return;
    activePopup.style.display = 'none';
    activePopup.setAttribute('aria-hidden', 'true');
    activePopup = null;
    document.body.style.overflow = previousBodyOverflow;
    if (returnFocusElement && document.contains(returnFocusElement)) {
      returnFocusElement.focus();
    }
    returnFocusElement = null;
  }

  function openPopup(titleBlock, trigger) {
    var popup = titleBlock && titleBlock.querySelector('.slt-activity-popup');
    if (!popup) return;

    closePopup();
    activePopup = popup;
    returnFocusElement = trigger;
    previousBodyOverflow = document.body.style.overflow;
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var closeButtons = popup.querySelectorAll('button[data-slt-activity-popup-close]');
    for (var i = 0; i < closeButtons.length; i += 1) {
      if (closeButtons[i].offsetParent !== null) {
        closeButtons[i].focus();
        break;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-slt-activity-popup-close]');
    if (closeButton) {
      event.preventDefault();
      closePopup();
      return;
    }

    var trigger = event.target.closest('[data-slt-activity-terms-trigger]');
    if (!trigger) return;
    var titleBlock = trigger.closest('[data-slt-activity-title]');
    if (!titleBlock) return;
    event.preventDefault();
    openPopup(titleBlock, trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (activePopup && event.target.contains(activePopup)) closePopup();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }
})();
